import Tranche from './Tranche';

export default Tranche;
